<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong><i class="fa fa-align-justify"/> Créer une nouvelle famille produit</strong>
          </div>
          <b-form>
            <b-form-group label="Gamme" label-for="basicSelect">
              <b-form-select
                id="basicSelect"
                :plain="true"
                :options="gammesOptions"
                v-model="selectedGamme">
              </b-form-select>
              <span class="field-error">{{ errors.selectedGamme }}</span>
            </b-form-group>
            <b-form-group label="Libellé" label-for="libelle">
              <b-form-input
                id="libelle"
                type="text"
                :class="{hasError: errors.libelle !== ''}"
                v-model="libelle"
              />
              <span class="field-error">{{ errors.libelle }}</span>
            </b-form-group>
            <b-form-group label="Grille Salaire" label-for="grille_salaire">
              <b-form-select id="grilleSalaire"
                            :plain="true"
                            :options="allGrilleSalaire"
                            v-model="selectedGrilleSalaire">
              </b-form-select>
            </b-form-group>
            <!-- <b-form-group>
              <template slot="label">Module taux</template>
              <b-form-radio-group
                id="radio-group-2-3"
                v-model="hasGrilleSalaireTaux"
                name="radio-hasGrilleSalaireTaux"
              >
                <b-form-radio value="true">Oui</b-form-radio>
                <b-form-radio value="false">Non</b-form-radio>
              </b-form-radio-group>
            </b-form-group> -->
            <b-form-checkbox v-model="activeIntegrationNsiAuto" name="active-mp" switch class="mb-2">
              Activer le produit pour Module Prev'
            </b-form-checkbox>
            <b-form-group label="Secteur">
              <b-form-checkbox-group
                id="checkbox-group-secteur"
                v-model="selectedSecteur"
                aria-describedby="choix secteur ESS et/ou Interpro"
                name="secteur"
              >
                <b-form-checkbox value="ess">ESS</b-form-checkbox>
                <b-form-checkbox value="interpro">INTERPRO</b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>
            <div class="mt-5" slot="footer">
              <b-button type="button" @click="returnBack" size="md" variant="secondary">
                <i class="fa fa-arrow-left"/> Liste des familles produit
              </b-button>
              <b-button type="button" @click="save" size="md" class="pull-right" variant="primary">
                <i class="fa fa-save"/> Enregistrer
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import { getAccessToken, getBaseUrl, getIdToken, getProvider } from '@/utils/auth'
  import { isEmpty } from "@/utils/fileHelper"

  export default {
    name: "Add",
    data() {
      return {
        libelle: "",
        gammesOptions: [],
        selectedGamme: null,
        allGrilleSalaire: [],
        selectedGrilleSalaire: '',
        activeIntegrationNsiAuto: '',
        // hasGrilleSalaireTaux: false,
        selectedSecteur: [],
        errors: {
          libelle: "",
          selectedGamme: ""
        },
      }
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
      this.getGammesProduit();
      this.getAllGrilleSalaire();
    },
    methods: {
      getGammesProduit() {
        let self = this;
        this.$store.commit('IS_LOADING', true);
        this.$axios
          .get('/espaceGestion/produit/gestion-gamme')
          .then(response => {
            this.$store.commit('IS_LOADING', false);
            const gammesProduit = response.data.gammesProduit;
            for (let i = 0; i < gammesProduit.length; i++) {
              let secteur = gammesProduit[i].secteur.toUpperCase().replace(',', ' | ');
              this.gammesOptions.push({
                text: gammesProduit[i].libelle + ' ( ' +secteur+ ' )',
                value: gammesProduit[i].id
              });
            }
          })
          .catch(() => {
            self.$store.commit("IS_LOADING", false);
            self.handleError();
          });
      },
      save() {
        let self = this;
        if (this.validateData()) {
          this.$store.commit("IS_LOADING", true);
          let dataPost = {};
          dataPost.libelle = this.libelle;
          dataPost.gammeId = this.selectedGamme
          dataPost.grillesSalaire = this.selectedGrilleSalaire;
          dataPost.activeIntegrationNsiAuto = this.activeIntegrationNsiAuto;
          // dataPost.hasGrilleSalaireTaux = this.hasGrilleSalaireTaux
          dataPost.secteur = this.selectedSecteur;
          this.$axios
            .post("/espaceGestion/produit/gestion-famille", dataPost)
            .then(() => {
              this.$store.commit("IS_LOADING", false);
              this.$swal({
                position: "top",
                type: "success",
                title: "Création avec succès",
                text: "La famille produit a été bien crée",
                showConfirmButton: false,
                timer: 5000
              });
              this.returnBack()
            })
            .catch(() => {
              self.$store.commit("IS_LOADING", false);
              self.handleError();
            });
        }
      },
      returnBack() {
        this.$router.push({path: "/espace-gestion/produit/gestion-famille/list"});
      },
      validateData() {
        this.clearErrors()
        let valid = true;
        if (isEmpty(this.libelle)) {
          this.errors.libelle = "Le libellé est obligatoire";
          valid = false;
        }
        if (this.selectedGamme === null) {
          this.errors.selectedGamme = "Le choix de la gamme est obligatoire";
          valid = false;
        }
        return valid;
      },
      clearErrors() {
        this.errors.libelle = "";
        this.errors.selectedGamme = "";
      },
      handleError() {
        this.$swal({
          position: 'top',
          type: 'error',
          title: 'Attention !!',
          text: 'Un problème est survenu, merci de contacter l\'administrateur',
          showConfirmButton: false,
          timer: 5000
        });
      },
      getAllGrilleSalaire() {
        this.$axios
          .get("/espaceGestion/produit/gestion-grille")
          .then(response => {
            let grillesSalaire = response.data.grillesSalaire;
            for (let key in grillesSalaire) {
              this.allGrilleSalaire.push({
                text: grillesSalaire[key].libelle,
                value: grillesSalaire[key].id
              });
            }
          })
          .catch(() => {
            this.handleError()
          });
      }
    }
  }
</script>
